import isVueComponent from './isVueComponent'
import capitalize from './capitalize'

export default function getComponent(is, componentMap, NotFoundError, suffix = '') {
  if (isVueComponent(is)) {
    return is
  }

  const component = componentMap[is]
    ?? componentMap[is + suffix]
    ?? componentMap[capitalize(is)]
    ?? componentMap[capitalize(is + suffix)]

  if (component) {
    return component
  }

  throw new NotFoundError(is)
}
